var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.selectedPackage.name))]),_vm._v(" "),_c('abstractTable',{attrs:{"columns":_vm.usagesColumns,"data":_vm.computedUsages,"classes":'ui very compact center aligned celled table'}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70cf6c50","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/visits/visit_components/MedicalMachinePackageUsages.vue
// module id = null
// module chunks = 